import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatInput = ({ onSendMessage, disabled = false, onAttachment }) => {
  const [message, setMessage] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (message?.trim() && !disabled) {
      onSendMessage(message?.trim());
      setMessage('');
      if (textareaRef?.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit(e);
    }
  };

  const handleTextareaChange = (e) => {
    setMessage(e?.target?.value);

    // Auto-resize textarea
    if (textareaRef?.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height =
        Math.min(textareaRef?.current?.scrollHeight, 120) + 'px';
    }
  };

  const handleAttachmentClick = () => {
    fileInputRef?.current?.click();
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (file && onAttachment) {
      onAttachment(file);
    }
  };

  const handleVoiceRecord = () => {
    setIsRecording(!isRecording);
    // Voice recording functionality would be implemented here
    console.log('Voice recording:', !isRecording);
  };

  return (
    <div className="sticky bottom-0 bg-background border-t border-border p-4">
      <form onSubmit={handleSubmit} className="flex items-end gap-3">
        {/* Attachment Button */}
        {/* <button
          type="button"
          onClick={handleAttachmentClick}
          disabled={disabled}
          className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-muted-foreground hover:text-foreground bg-muted hover:bg-muted/80 rounded-full transition-smooth focus-ring disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Icon name="Paperclip" size={20} />
        </button> */}

        {/* Hidden File Input */}
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
          onChange={handleFileChange}
          className="hidden"
        />

        {/* Message Input */}
        <div className="flex-1 relative">
          <textarea
            ref={textareaRef}
            value={message}
            onChange={handleTextareaChange}
            onKeyPress={handleKeyPress}
            placeholder="سوال حقوقی خود را بپرسید..."
            disabled={disabled}
            className="w-full min-h-[44px] max-h-[120px] px-4 py-3 pr-12 text-sm bg-input border border-border rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed transition-smooth"
            rows={1}
          />

          {/* Voice Record Button */}
          <button
            type="button"
            onClick={handleVoiceRecord}
            disabled={disabled}
            className={`absolute left-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full transition-smooth focus-ring ${
              isRecording
                ? 'text-error bg-error/10 hover:bg-error/20'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
            } disabled:opacity-50 disabled:cursor-not-allowed`}>
            <Icon name={isRecording ? 'Square' : 'Mic'} size={16} />
          </button>
        </div>

        {/* Send Button */}
        <Button
          type="submit"
          variant="default"
          size="icon"
          disabled={!message?.trim() || disabled}
          className="flex-shrink-0 w-10 h-10 rounded-full">
          <Icon name="Send" size={18} />
        </Button>
      </form>
      {/* Recording Indicator */}
      {isRecording && (
        <div className="flex items-center justify-center mt-2 p-2 bg-error/10 rounded-lg animate-pulse">
          <Icon name="Mic" size={16} className="text-error ml-2" />
          <span className="text-sm text-error font-medium">
            در حال ضبط صدا...
          </span>
        </div>
      )}
    </div>
  );
};

export default ChatInput;
